@use '../../../scss/settings/colors';
@use '../../../scss/settings/breakpoints';

// Same look as the Document Vault documents block (DocumentVault.module.scss).
$block-radius: 16px;
$control-height: 40px;
$switcher-bg: #eef0f4;
$active-bg: colors.$light-purple;

// Actions + table as one rounded block (list view, or a workflow open in the card view).
.documents_block {
  width: 100%;
  overflow: hidden;
  background-color: colors.$base-white;
  border: 1px solid colors.$gray-variant-4;
  border-radius: $block-radius;

  .block_header {
    border-bottom: 1px solid colors.$gray-variant-4;
  }
}

// Actions as a rounded block of their own, in one row with the Workflows subheader (the row is
// `justify-content: space-between`; the auto margin keeps the block on the right when it is alone).
.block_header.block_header_standalone {
  margin-left: auto;
  padding: 0;
  background-color: transparent;
  border: none;
  border-radius: $block-radius;
}

.block_content {
  position: relative;
}

.block_header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px;
  background-color: colors.$base-white;
}

// Pagination + view switcher, on the right.
.header_controls {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-left: auto;
}

.header_pagination {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pages_value:global(.MuiTypography-root) {
  font-family: 'Medium Inter', sans-serif;
  font-size: 0.8125rem;
  color: colors.$gray-variant-16;
}

.pagination:global(.MuiPagination-root) {

  :global(.MuiPagination-ul) {
    gap: 4px;
  }

  :global(.MuiPaginationItem-root) {
    min-width: 32px;
    height: 32px;
    margin: 0;
    font-family: 'Medium Inter', sans-serif;
    font-size: 0.8125rem;
    color: colors.$dark-blue;
    border-radius: 8px;

    &:global(.Mui-selected) {
      color: colors.$brand-purple;
      background-color: $active-bg;
    }
  }
}

// Card / list switcher: icon-only segmented control.
.card_list_view_container {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 2px;
  height: $control-height;
  padding: 3px;
  background-color: $switcher-bg;
  border-radius: 10px;
}

.variant_btn_wrapper {
  display: inline-flex;
}

.variant_btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  padding: 0;
  color: colors.$dark-blue;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;

  &[disabled] {
    opacity: 0.5;
    cursor: default;
  }

  &:hover:not([disabled]) {
    color: colors.$brand-purple;
  }

  &.variant_btn_active:not([disabled]) {
    color: colors.$brand-purple;
    background-color: colors.$base-white;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
  }

  &:focus-visible {
    outline: 2px solid colors.$brand-purple;
    outline-offset: 1px;
  }

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor !important;
  }
}

.visually_hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

// Mobile: the pagination on the left, the switcher on the right.
.header_controls {

  @media #{breakpoints.$mobile}{
    justify-content: space-between;
    width: 100%;
    gap: 8px;
  }

}

.header_controls .card_list_view_container {

  @media #{breakpoints.$mobile}{
    margin-left: auto;
  }

}
